import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import WarehouseAllocationForm from "./warehouseAllocationComponents/WarehouseAllocationForm";

import { useAddWarehouseAllocationMutation } from "store/services/warehouseAllocationApi";

const WarehouseAllocationCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Warehouse Allocations", path: "/app/crm/warehouse-allocation/list" },
    { title: "New Allocation" },
  ];

  // RTK query hook for adding a warehouse allocation
  const [addWarehouseAllocation, { isLoading }] = useAddWarehouseAllocationMutation();

  const handleCreateWarehouseAllocation = async (data) => {
    try {
      const { _id } = await addWarehouseAllocation(data).unwrap();
      toast.success("Warehouse allocation successfully created!");
      navigate(`/app/crm/warehouse-allocation/${_id}/detail`); // Navigate to the newly created allocation's detail page
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create warehouse allocation!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <WarehouseAllocationForm isBusy={isLoading} onSubmit={handleCreateWarehouseAllocation} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default WarehouseAllocationCreateScreen;
